const state = function () {
  return {
    config: {},
    data: {}
  }
}

function rebuildParentsCash (state) {
  let parentsCash = {}
  for (let type in state.data) {
    for (let item in state.data[type]) {
      for (let child in state.data[type][item].children) {
        parentsCash[state.data[type][item].children[child]] = [type, item]
      }
    }
  }
  state.parentsCash = parentsCash
}

const mutations = {
  addLeaf (state) {
  },
  updateData (state, data) {
    state.data = Object.assign({}, state.data, data)
    rebuildParentsCash(state)
  },
  updateConfig (state, config) {
    state.config = Object.assign({}, state.config, config)
  }
}

const actions = {
  configure (context, config) {
    context.commit('updateConfig', config)
  },
  loadData (context, data) {
    context.commit('updateData', data)
  }
}

const getters = {
  getLeaf (state) {
    return (type, id) => {
      return state.data[type][id]
    }
  },
  getLevel (state) {
    return (type, id) => {
      let item = [type, id]
      let level = 0
      while (item) {
        item = state.parentsCash[item]
        level += 1
      }
      return level
    }
  },
  tagByModel (state) {
    return (model) => {
      return state.config.tags[model]
    }
  },
  modelByTag (state) {
    return (tag) => {
      let object = state.config.tags
      return Object.keys(object).find(key => object[key] === tag)
    }
  },
  translatableProps (state) {
    return (model) => {
      return state.config.translatableProps[model]
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions,
  namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/modules/bz-tree/index.js